import { render } from "./BankAccountsTable.vue?vue&type=template&id=161c34f7"
import script from "./BankAccountsTable.vue?vue&type=script&lang=ts"
export * from "./BankAccountsTable.vue?vue&type=script&lang=ts"

import "./BankAccountsTable.vue?vue&type=style&index=0&id=161c34f7&lang=scss"
script.render = render

export default script